







import blockMixin from './../BlockMixin.vue'

export default {
  name: 'heading-mixin'

  mixins: [blockMixin]

  data: -> {
    fields: {
      content: ''
    }
  }

  mounted: ->
    this.$el.querySelector('.bb8-form-control').focus() if this.block.fields.content.length <= 0

  methods: {
    removeBlock: (event) ->
      return if event.target.value.length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/SingleTextMixin.vue